// src/modules/mapas/leafletLoader.js — lazy loader Leaflet + plugins
// Carrega Leaflet core via npm (já no chunk vendor-leaflet) e plugins via CDN sob demanda.

let _coreLoaded = null;

export async function ensureLeaflet() {
  if (_coreLoaded) return _coreLoaded;
  _coreLoaded = (async () => {
    const L = (await import('leaflet')).default;
    // CSS oficial Leaflet
    await import('leaflet/dist/leaflet.css');
    window.L = L; // plugins do CDN esperam window.L
    return L;
  })();
  return _coreLoaded;
}

export async function ensureCluster() {
  const L = await ensureLeaflet();
  if (typeof L.markerClusterGroup === 'function') return L;
  await _loadScript('https://cdn.jsdelivr.net/npm/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js');
  if (!document.querySelector('link[href*="MarkerCluster.css"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/leaflet.markercluster@1.4.1/dist/MarkerCluster.css';
    document.head.appendChild(link);
  }
  return L;
}

export async function ensureHeat() {
  const L = await ensureLeaflet();
  if (typeof L.heatLayer === 'function') return L;
  await _loadScript('https://cdn.jsdelivr.net/npm/leaflet.heat@0.2.0/dist/leaflet-heat.js');
  return L;
}

export async function ensureHtml2Canvas() {
  if (typeof window.html2canvas !== 'undefined') return window.html2canvas;
  // html2canvas-pro: fork com suporte a oklch()/color-mix() (tokens shadcn v4)
  await _loadScript('https://cdn.jsdelivr.net/npm/html2canvas-pro@1.5.8/dist/html2canvas-pro.min.js');
  return window.html2canvas;
}

function _loadScript(src) {
  return new Promise((res, rej) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      res();
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.onload = () => res();
    s.onerror = (e) => rej(e);
    document.head.appendChild(s);
  });
}
